import * as R from 'ramda';
import * as actionTypes from '../actionTypes';

const badgeState = {
  isLoadingGetBadgeSetting: false,
  getBadgeSettingMessage: '',
  getBadgeSettingFailed: '',

  isLoadingPostBadgeSetting: false,
  postBadgeSettingMessage: '',
  postBadgeSettingFailed: '',

  isLoadingDeleteBadgeSetting: false,
  deleteBadgeSettingMessage: '',
  deleteBadgeSettingFailed: '',

  isLoadingPutBadgeSetting: false,
  putBadgeSettingMessage: '',
  putBadgeSettingFailed: '',
};

const initialBadgeState = R.clone(badgeState);

function badgeReducer(state = badgeState, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialBadgeState,
      };
    case actionTypes.GET_BADGE_SETTING_PENDING:
      return {
        ...state,
        isLoadingGetBadgeSetting: true,
      };
    case actionTypes.GET_BADGE_SETTING_FULFILLED:
      return {
        ...state,
        isLoadingGetBadgeSetting: false,
        getBadgeSettingMessage: action.data,
        getBadgeSettingFailed: '',
      };
    case actionTypes.GET_BADGE_SETTING_FAILURE:
      return {
        ...state,
        isLoadingGetBadgeSetting: false,
        getBadgeSettingMessage: '',
        getBadgeSettingFailed: action.error,
      };
    case actionTypes.POST_BADGE_SETTING_PENDGING:
      return {
        ...state,
        isLoadingPostBadgeSetting: true,
      };
    case actionTypes.POST_BADGE_SETTING_FULFILLED:
      return {
        ...state,
        isLoadingPostBadgeSetting: false,
        postBadgeSettingMessage: action.data,
        postBadgeSettingFailed: '',
      };
    case actionTypes.POST_BADGE_SETTING_FAILURE:
      return {
        ...state,
        isLoadingPostBadgeSetting: false,
        postBadgeSettingMessage: '',
        postBadgeSettingFailed: action.error,
      };
    case actionTypes.DELETE_BADGE_SETTING_PENDING:
      return {
        ...state,
        isLoadingDeleteBadgeSetting: true,
      };
    case actionTypes.DELETE_BADGE_SETTING_FULFILLED:
      return {
        ...state,
        isLoadingDeleteBadgeSetting: false,
        deleteBadgeSettingMessage: action.data,
        deleteBadgeSettingFailed: '',
      };
    case actionTypes.DELETE_BADGE_SETTING_FAILURE:
      return {
        ...state,
        isLoadingDeleteBadgeSetting: false,
        deleteBadgeSettingMessage: '',
        deleteBadgeSettingFailed: action.error,
      };
    case actionTypes.PATCH_BADGE_SETTING_PENDING:
      return {
        ...state,
        isLoadingPutBadgeSetting: true,
      };
    case actionTypes.PATCH_BADGE_SETTING_FULFILLED:
      return {
        ...state,
        isLoadingPutBadgeSetting: false,
        putBadgeSettingMessage: action.data,
        putBadgeSettingFailed: '',
      };
    case actionTypes.PATCH_BADGE_SETTING_FAILURE:
      return {
        ...state,
        isLoadingPutBadgeSetting: false,
        putBadgeSettingMessage: '',
        putBadgeSettingFailed: action.error,
      };
    default:
      return state;
  }
}

export default badgeReducer;
